<template>
    <div>
        <div v-on:click="showModal">
            <ion-icon name="warning"
                      data-toggle="tooltip"
                      data-placement="top"
                      :title="this.error"
                      style="color: #fa8629"
                      class="mb--1"
            ></ion-icon>
        </div>
        <div class="modal fade error-modal" :id="getModalId" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog task-form" role="document">
                <div class="modal-content">
                    <div class="modal-body">
                        <fieldset class="form-group tasks-started">
                            <legend class="close-modal">
                                <strong>Failed</strong>
                                <p>{{ this.connection.name }}</p>
                                <div class="justify-content-end">
                                    <button class="btn close close-modal" data-dismiss="modal">
                                        <ion-icon name="close"></ion-icon>
                                    </button>
                                </div>
                            </legend>
                        </fieldset>
                        <div class="form-group controls mt-2 text-break">
                            Error: {{ this.error }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            connection: {
                type: Object,
                default: {}
            },
            processId: {
                type: Number,
                default: 0
            },
            error: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
            }
        },
        computed: {
            getModalId() {
                return 'error-modal' + this.connection.id + this.processId;
            }
        },
        methods: {
            showModal() {
                $('#error-modal' + this.connection.id + this.processId).modal('show');
                setTimeout(() => {
                    $('[data-toggle="tooltip"]').tooltip();
                }, 100);
            }
        }
    }

</script>

<style scoped lang="scss">
div.error-modal {
    button.btn.close.close-modal {
        top: -70px;
        position: relative;
    }

    legend.close-modal {
        max-height: 55px;
    }
}
</style>
